// colour codes imported and used all over app for styling
const colours = {
    dark: "#334a52",
    //mid: "#94e5d1",
    mid: "#C7E4EE",
    light: "#edfdf8",
    navbar: "black",
    lightgrey: "#D2D2CF",
    white: "#FFF",
    black: "#000",
};

export default colours;